import React from "react";
import Header from "./Header";

function Prueba() {
  return (
    
    <div>
          <Header />
      <h1>Página de Prueba</h1>
      <p>Esto es solo un mensaje.</p>
    </div>
  );
}

export default Prueba;
